import React from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import PurchaseOrderForm from './PurchaseOrderForm';
import { createPurchaseOrder } from '../../collections/purchaseOrders';

const CreatePurchaseOrder = () => {
  const navigate = useNavigate();

  const handleCreatePurchaseOrder = async (formData) => {
    try {
      const result = await createPurchaseOrder(formData);
      toast.success('Tạo đơn đặt hàng thành công!', {
        position: 'top-center',
        autoClose: 2000,
      });
      // Navigate to purchase orders list
      navigate('/purchase-orders');
    } catch (error) {
      let errorMessage = "Đã xảy ra lỗi không xác định!";
      if (error.response?.data?.error) {
        // Handle different error formats
        if (typeof error.response.data.error === 'string') {
          errorMessage = error.response.data.error;
        } else if (typeof error.response.data.error === 'object') {
          // Concatenate all error messages from the backend
          errorMessage = Object.values(error.response.data.error).flat().join('; ');
        }
      }
      toast.error(errorMessage, {
        position: 'top-center',
        autoClose: 3000,
      });
      throw error; // Re-throw to let form handle it
    }
  };

  return <PurchaseOrderForm onSubmit={handleCreatePurchaseOrder} />;
};

export default CreatePurchaseOrder;